// extracted by mini-css-extract-plugin
export default {"page":"coming-soon_page__+uJZ9","title":"coming-soon_title__QmLs2","text":"coming-soon_text__cHLZU"};